import React from 'react';

export const SvgNavMyWaypoints = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="15"
      height="21"
      viewBox="0 0 15 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 7.11388C1 3.73716 3.91002 1 7.5 1C11.09 1 14 3.73716 14 7.11388C14 10.4906 9.85469 16.6806 8.18433 19.0105C7.85637 19.4671 7.14363 19.4671 6.81567 19.0105C5.14531 16.6806 1 10.5502 1 7.11388Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M7.5 11.3529C9.03851 11.3529 10.2857 10.0098 10.2857 8.35294C10.2857 6.69608 9.03851 5.35294 7.5 5.35294C5.96149 5.35294 4.71429 6.69608 4.71429 8.35294C4.71429 10.0098 5.96149 11.3529 7.5 11.3529Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
    </svg>
  );
};
